/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { ComplianceTimelineEventPayload } from './';
import {
    ComplianceTimelineEventPayloadFromJSON,
    ComplianceTimelineEventPayloadFromJSONTyped,
    ComplianceTimelineEventPayloadToJSON,
} from './';

/**
 * 
 * @export
 * @interface PartnerKycStatusTimelinePayload
 */
export interface PartnerKycStatusTimelinePayload extends ComplianceTimelineEventPayload {
    /**
     * 
     * @type {string}
     * @memberof PartnerKycStatusTimelinePayload
     */
    partnerName: string;
}

/**
 * Check if a given object implements the PartnerKycStatusTimelinePayload interface.
 */
export function instanceOfPartnerKycStatusTimelinePayload(value: object): value is PartnerKycStatusTimelinePayload {
    if (!('partnerName' in value) || value['partnerName'] === undefined) return false;
    return true;
}

export function PartnerKycStatusTimelinePayloadFromJSON(json: any): PartnerKycStatusTimelinePayload {
    return PartnerKycStatusTimelinePayloadFromJSONTyped(json, false);
}

export function PartnerKycStatusTimelinePayloadFromJSONTyped(json: any, ignoreDiscriminator: boolean): PartnerKycStatusTimelinePayload {
    if (json == null) {
        return json;
    }
    if (!ignoreDiscriminator) {
    }
    return {
        ...ComplianceTimelineEventPayloadFromJSONTyped(json, ignoreDiscriminator),
        'partnerName': json['partnerName'],
    };
}

export function PartnerKycStatusTimelinePayloadToJSON(value?: PartnerKycStatusTimelinePayload | null, ignoreDiscriminator?: boolean): any {
    if (value == null) {
        return value;
    }
    if (!ignoreDiscriminator) {
    }
    return {
        ...ComplianceTimelineEventPayloadToJSON(value, true),
        'partnerName': value['partnerName'],
    };
}

